module.exports = __webpack_public_path__ + "img/Group23.e9314db1.png";